export default __webpack_public_path__ + "static/media/commande_CF_fr.14c38f15.pdf";